/**
 * SR26 · UGC — kundinnehåll taggat till produkten.
 * Hämtas via vår worker; Reviews.io-nyckeln stannar där.
 */
(function () {
  'use strict';

  var SEC = document.querySelector('[data-sr26-ugc]');
  if (!SEC || SEC.dataset.ugcInit) return;
  SEC.dataset.ugcInit = '1';

  var API = SEC.dataset.api.replace(/\/$/, '');
  var SKU = SEC.dataset.sku;
  var LIMIT = parseInt(SEC.dataset.limit, 10) || 12;
  var row = SEC.querySelector('[data-ugc-row]');

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function card(u) {
    // Bara bilden. Ingen bildtext och ingen länk: produktnamnet under varje
    // bild upprepade sidan man redan står på, och en länk ut till Instagram
    // mitt i en produktsida skickar bort kunden precis före köpet.
    // Produktnamnet lever kvar i alt-texten, där det gör nytta.
    var alt = (u.products && u.products[0]) || (window.sr26I18n || {}).ugc_alt || 'Kundbild';
    return (
      '<li class="sr26-ugc__item">' +
        '<img class="sr26-ugc__img" src="' + esc(u.image.md) + '" ' +
          'srcset="' + esc(u.image.sm) + ' 500w, ' + esc(u.image.md) + ' 1080w" ' +
          'sizes="(min-width: 992px) 220px, 45vw" loading="lazy" ' +
          'alt="' + esc(alt) + '">' +
      '</li>'
    );
  }

  function load() {
    fetch(API + '/ugc?sku=' + encodeURIComponent(SKU) + '&limit=' + LIMIT)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var items = (d.ugc || []).filter(function (u) {
          // Bara det som faktiskt är taggat till DEN HÄR produkten. Workern
          // faller tillbaka på hela flödet när inget är taggat, och den
          // reserven vill vi inte ha här.
          return (u.tagged || []).indexOf(SKU) !== -1;
        });
        if (!items.length) return;
        row.innerHTML = items.map(card).join('');
        SEC.hidden = false;
      })
      .catch(function () {});
  }

  // INTE IntersectionObserver: sektionen börjar som hidden, och ett element
  // utan layoutbox rapporteras aldrig som synligt — observern hade tystnat
  // för alltid. Anropet är litet, så det körs när huvudtråden är ledig.
  if ('requestIdleCallback' in window) {
    requestIdleCallback(load, { timeout: 2500 });
  } else {
    setTimeout(load, 1200);
  }
})();
